import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild, Renderer2, NgZone, ElementRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { LoaderService } from 'src/app/core/helpers/loader.service';
import { RecaptchaComponent } from 'ng-recaptcha';
import { DeviceFingerprintService } from 'src/app/core/helpers/device-fingerprint.service';



@Component({
    selector: 'loyaltic-participate-with-email',
    templateUrl: './participate-with-email.component.html',
    styleUrls: ['./participate-with-email.component.scss'],
    standalone: false
})
export class ParticipateWithEmailComponent implements OnInit, OnDestroy {

  receipt: any;
  Quantity = 0;
  ReceiptName = '';
  Phone = '';
  IsAcceptTerms = false;
  IsPrivacyPolicy = false;
  IsUserAlreadyLoggedIn = false;
  isUserAlreadyRegistered = true;
  calendarBoosted = false;
  receiptSrc: any;
  receiptNotApprovedData: any;
  userId = '';
  Email = '';
  LoginType = 'Email';
  culture = '';
  clicked = false;
  submitted = false;
  siteKey = "6LfD1hYsAAAAAGjk6Jx6Vyy5tHHiq6brYSrwuU2L";
  token: string = '';
  fingerprint: string = '';
  

  @Output() receiptUploadSuccess = new EventEmitter<any>();
  @ViewChild('invisible') invisibleCaptcha: ElementRef<RecaptchaComponent>;


  constructor(private authService: AuthService, private coreService: CoreService,
    private toast: ToastrService, private translate: TranslateService, private loaderService: LoaderService,
    private router: Router,
    private gaService: GaService,
    private modalService: BsModalService,
    private renderer: Renderer2,
    private fp: DeviceFingerprintService,
    @Inject(DOCUMENT) private document: Document) {
      this.culture = translate.getDefaultLang();
    }


  async ngOnInit() {
    this.fingerprint = await this.fp.getFingerprint();
    this.resetToken();
    this.renderer.addClass(this.document.body, 'participate-with-email-page');
    this.userId = this.authService.getUserId();
    if (this.userId) {
      this.IsUserAlreadyLoggedIn = true;
      this.coreService.getEmailAndPhone(this.userId).then((response:any) =>{
        console.log('userr', response);
        this.Email = response.result.userName;
      })
    }

  }

  submit() {
    if (this.isUserAlreadyRegistered) {
      this.participate();
    } else {
      this.invisibleCaptcha.nativeElement.execute();
    }
  }

  public addTokenLog(message: string, token: string | null) {
    console.log("===toekn", token)
    this.token = token;
  }

  public onError() {
    console.log(`reCAHPTCHA errored;`);
  }


  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'participate-with-email-page');
  }
  resetToken() {
    const tokenTime = this.authService.getTokenTime();
    if (tokenTime) {
      const differenceMs = +new Date().getTime() - +new Date(tokenTime).getTime();
      const sec = differenceMs / 1000;
      const hours = sec / 3600;
      if (hours > 24) { this.authService.resetTokens() }
    }
  }

  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement('img');
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }

  showAnimationPopup() {
    // this.modalRef = this.modalService.show(this.uploadAnimationRef, this.popupConfig);
  }

  participate() {

    const formData = new FormData();

    this.Quantity = this.receipt? 1:0
    localStorage.setItem('LoginType',this.LoginType)

      formData.append('LoginType', this.LoginType.toString())
      formData.append('Value', this.Email);
      formData.append('CanRegisterUser', this.isUserAlreadyRegistered ? 'false' : 'true');
      formData.append('HasOptedForMarkettingEmail', this.IsPrivacyPolicy ? 'true' : 'false');
      formData.append('Culture', this.translate.getDefaultLang());
      if (!this.isUserAlreadyRegistered) {
        formData.append('RecaptchaToken', this.token);
        formData.append('DeviceFingerprint', this.fingerprint);
      }
      this.coreService.participate(formData).then((response: any) => {
        this.clicked = true;
        this.isUserAlreadyRegistered = true;
        this.IsUserAlreadyLoggedIn = true;
        this.coreService.login();
        if (response.result.isNewUser){
          this.gaService.emitEvent('new_user', 'Participate Screen');
          sessionStorage.setItem('session','true')
        } else if(sessionStorage.getItem('session') != 'true') {
          this.gaService.emitEvent('returning_user', 'Participate Screen');
        }

        //form.submitted = false;
        this.resetForm();
        const result = response.result;
        this.authService.setToken(result.token, result.id);
        localStorage.setItem('participateApiResult', JSON.stringify(response.result));
        localStorage.setItem('isWithFlow', '1');
        this.router.navigate(['/']);
        //response.result.isIntermediatePlayPageEnabled ? this.router.navigate(['click-to-play']): this.router.navigate(['play']);
      }).catch((errorResponse: any) => {
        //form.submitted = false;
        this.submitted = false;
        this.isUserAlreadyRegistered = false;
        this.clicked = false;
        // this.modalRef.hide();
        console.log('error', errorResponse);
      });
  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate([this.router.url])
  }

  onKeyPress(event: KeyboardEvent) {
    if (event.key === '+') {
      event.preventDefault();
    }
  }
    

  blockPlus(event: KeyboardEvent) {
      if (event.key === '+') {
        event.preventDefault();
      }
    }

    cleanPaste(event: ClipboardEvent) {
    event.preventDefault(); // stop default paste behavior

    let pasted = event.clipboardData?.getData('text') ?? '';

    // Remove all + signs
    pasted = pasted.replace(/\+/g, '');

    // Insert cleaned text into the input box
    const input = event.target as HTMLInputElement;
    input.value = pasted;

    // If using ngModel, update the binding:
    this.Email = pasted;
  }


  resetForm() {
    this.receipt = undefined;
    this.Phone = undefined;
    this.ReceiptName = undefined;
    this.IsAcceptTerms = false;
    this.IsPrivacyPolicy = false;
  }
}
